// NAS의 server/data/*.json 파일에만 저장/로드 (localStorage 미사용)

const BACKUP_PREFIX = '__mes_backup_';

// 저장 실패 시 localStorage에 임시 백업
const writeBackup = (key, data) => {
  try { localStorage.setItem(BACKUP_PREFIX + key, JSON.stringify(data)); } catch {}
};
const clearBackup = (key) => {
  try { localStorage.removeItem(BACKUP_PREFIX + key); } catch {}
};

export const readBackup = (key) => {
  try {
    const raw = localStorage.getItem(BACKUP_PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const hasPendingBackup = () => {
  try {
    return Object.keys(localStorage).some(k => k.startsWith(BACKUP_PREFIX));
  } catch { return false; }
};

export const getPendingBackupKeys = () => {
  try {
    return Object.keys(localStorage)
      .filter(k => k.startsWith(BACKUP_PREFIX))
      .map(k => k.replace(BACKUP_PREFIX, ''));
  } catch { return []; }
};

let saveErrorCallback = null;
export const onSaveError = (cb) => { saveErrorCallback = cb; };

export const saveToServer = async (key, data, { force = false } = {}) => {
  try {
    const url = force ? `/api/data/${key}?force=1` : `/api/data/${key}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      console.error(`[MES] 서버 저장 실패 (${key}) HTTP ${res.status}`);
      writeBackup(key, data);
      if (saveErrorCallback) saveErrorCallback(key, `HTTP ${res.status}`);
    } else {
      clearBackup(key);
    }
  } catch (e) {
    console.error(`[MES] 서버 연결 오류 (${key}):`, e.message);
    writeBackup(key, data);
    if (saveErrorCallback) saveErrorCallback(key, e.message);
  }
};

export const loadAllFromServer = async () => {
  const res = await fetch('/api/data');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};
